export default {
  ADMIN: 'ADMIN',
  CUSTOMER: 'CUSTOMER',
  SUPER_CUSTOMER: 'SUPER_CUSTOMER'
}
